import {HttpClient, HttpParams}      from '@angular/common/http';
import {Injectable}                  from '@angular/core';
import {DocumentIntentPayload, DocumentParentType, DocumentUploadIntent, OperationalDocument} from '@src/app/shared/models/document.model';
import {environment}                 from '@src/environments/environment';
import {from, Observable, switchMap} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DocumentsService
{
    public constructor(private httpClient: HttpClient)
    {
    }

    public list(documentableType: DocumentParentType, documentableId: string): Observable<{ data: OperationalDocument[] }>
    {
        return this.httpClient.get<{ data: OperationalDocument[] }>(`${environment.apiUrl}/documents`, {
            params: new HttpParams()
                .set('documentable_type', documentableType)
                .set('documentable_id', documentableId),
        });
    }

    public createIntent(payload: DocumentIntentPayload): Observable<{ data: DocumentUploadIntent }>
    {
        return this.httpClient.post<{ data: DocumentUploadIntent }>(`${environment.apiUrl}/documents/intent`, payload);
    }

    public upload(uploadUrl: string, file: File, contentType: string): Observable<void>
    {
        return from(fetch(uploadUrl, {
            method: 'PUT',
            headers: {'Content-Type': contentType},
            body: file,
        })).pipe(switchMap(async (response) => {
            if (!response.ok) {
                throw new Error(`Document upload failed (${response.status}).`);
            }
        }));
    }

    public finalize(id: string, checksum: string): Observable<{ data: OperationalDocument }>
    {
        return this.httpClient.post<{ data: OperationalDocument }>(`${environment.apiUrl}/documents/${id}/finalize`, {checksum});
    }

    public update(id: string, changes: Partial<Pick<OperationalDocument, 'category' | 'title' | 'visible_to_customer' | 'visible_on_app' | 'include_in_report'>>): Observable<{ data: OperationalDocument }>
    {
        return this.httpClient.patch<{ data: OperationalDocument }>(`${environment.apiUrl}/documents/${id}`, changes);
    }

    public download(id: string): Observable<{ data: { url: string } }>
    {
        return this.httpClient.get<{ data: { url: string } }>(`${environment.apiUrl}/documents/${id}/download`);
    }

    public delete(id: string): Observable<void>
    {
        return this.httpClient.delete<void>(`${environment.apiUrl}/documents/${id}`);
    }
}
